'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');
const components_forms_TextInput_TextInput = require('../../forms/TextInput/TextInput.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = styleEncapsulation.labelStyles("SubscriptionForm", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    flex-direction: column;
    gap: var(--zds-space-8);
    margin: 0 auto;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      margin: 0;
      align-items: center;
      flex-direction: row;
    }
  `,
  inputField: (fluidInput) => react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    text-align: left;
    ${fluidInput && styleEncapsulation.withModifier("fluid", react.css`
        flex: 1 100%;
        @media screen and (min-width: ${breakpoints.tablet}px) {
          flex: 2;
        }
      `)}
  `
});
const SubscriptionForm = (_a) => {
  var { inputIsFullWidth = true, fluidInput = false } = _a, props = tslib_es6.__rest(_a, ["inputIsFullWidth", "fluidInput"]);
  const [id] = React.useState(props.inputId || utils_uniqueId.uniqueId("SubscriptionForm-"));
  const [subscribedValue, setSubscribedValue] = React.useState("");
  const inputSize = "medium";
  const inputProps = {
    id,
    isDisabled: props.inputIsDisabled,
    isErrored: !!props.inputError,
    isRequired: props.inputIsRequired,
    isFullWidth: inputIsFullWidth,
    placeholder: props.placeholderText,
    ariaLabel: props.placeholderText,
    size: inputSize,
    onChange: (event) => setSubscribedValue(event.target.value)
  };
  return react.jsx(
    "form",
    { onSubmit: () => {
      var _a2;
      return (_a2 = props.onSubmit) === null || _a2 === void 0 ? void 0 : _a2.call(props, subscribedValue);
    }, "data-testid": "subscription-form", "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.root, "data-zds": true },
      react.jsx("div", { css: Styles.inputField(fluidInput), "data-zds": true }, props.renderInput ? props.renderInput(inputProps) : react.jsx(components_forms_TextInput_TextInput.TextInput, Object.assign({}, inputProps))),
      props.renderButton({ size: "medium" })
    )
  );
};

exports.SubscriptionForm = SubscriptionForm;
//# sourceMappingURL=SubscriptionForm.cjs.js.map
